module.exports = __webpack_public_path__ + "static/30-kva-transformer-distribution-b6852f856f7f1fe04b9e0b5835f748c3.jpg";